import { Controller } from '@hotwired/stimulus';
const STORAGE_KEY = 'topology.troubleshootingGuideLanguage';
const DEFAULT_LANGUAGE = 'en';
// Switches the Troubleshooting Guide between its English and Brazilian Portuguese renders.
//
// Both are generated server-side (TopologyPresenter::Runbooks#store_troubleshooting_html!) and sit in the
// page as panels marked with their `lang`; this only shows one and hides the other, and remembers the
// reader's choice in the browser. A topology stored before the Portuguese render existed has only the
// English panel and no toggle, so a remembered "pt-BR" falls back to English there.
class default_1 extends Controller {
    connect() {
        const saved = this.saved();
        this.show(saved && this.available(saved) ? saved : DEFAULT_LANGUAGE);
    }
    choose(event) {
        const lang = event.params?.lang;
        if (!lang || !this.available(lang))
            return;
        this.show(lang);
        try {
            window.localStorage.setItem(STORAGE_KEY, lang);
        }
        catch {
            // Storage can be unavailable (private mode, blocked site data); the choice then lasts this page only.
        }
    }
    show(lang) {
        this.panelTargets.forEach((panel) => {
            panel.hidden = panel.getAttribute('lang') !== lang;
        });
        this.buttonTargets.forEach((button) => {
            const selected = button.dataset.runbookLanguageLangParam === lang;
            button.classList.toggle('active', selected);
            button.setAttribute('aria-pressed', String(selected));
        });
    }
    available(lang) {
        return !!lang && this.panelTargets.some((panel) => panel.getAttribute('lang') === lang);
    }
    saved() {
        try {
            return window.localStorage.getItem(STORAGE_KEY);
        }
        catch {
            return null;
        }
    }
}
default_1.targets = ['button', 'panel'];
export default default_1;
